<template name="trainingCourse">
  <div class="traningCourse" v-if="lessonList.length">
    <div class="course-txt"><span>{{$t('course')}}</span></div>
    <div class="course-list" v-for="(item, index) in lessonList">
      <router-link :to="'/external/training/' + routeId + '/' + item.categoryId">
        <div class="row">
          <div class="col-3 left">
            <img :src="item.categoryPhoto">
          </div>
          <div class="col-8 middle">
            <div class="course-name">
              <div class="course-categoryName">
                <span>{{item.categoryName}}</span>
              </div>
            </div>
            <div class="course-status">
              <i class="iconfont icon-clock"></i><span>{{$t('learningProgress')}}: {{item.studiedCount}}/{{item.totalCount}}</span>
            </div>
          </div>
          <div class="col-1 right">
            <i class="iconfont icon-right"></i>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script type="text/javascript">
  export default {
    name: 'trainingCourse',
    data() {
      return {
        lessonList: [],
        routeId: 0,
      }
    },
    created() {
      this.routeId = this.$route.params.id;
    },
    watch: {
      $route() {
        this.routeId = this.$route.params.id;
      },
    },
    methods: {
      loadData(data) {
        if (data) {
          this.lessonList = data;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "../../scss/variables.scss";
  .traningCourse {
    box-shadow: 0 10px 25px rgba(100, 100, 100, 0.1);
    padding: 20px;
    .course-txt {
      padding-bottom: 20px;
      span {
        font-size: 16px;
        color: #4a4a4a;
        font-weight: 600;
      }
    }
    .course-list {
      box-shadow: 0 0 15px rgba(100, 100, 100, 0.1);
      border-radius: 4px;
      position: relative;
      margin-bottom: 20px;
      line-height: 1;
      background-color: #fff;
      padding: 0 12px;
      a {
        color: #4a4a4a;
      }
      a:hover {
        text-decoration: none;
      }
      .row {
        margin: 0;
        align-items: center;
        line-height: 55px;
        @include respond-to('sm-max') {
          line-height: 50px;
        }
        @include respond-to('ml') {
          line-height: 55px;
        }
        .left {
          padding: 0;
          img {
            width: 100%;
            height: 70px;
          }
        }
        .middle {
          .course-name {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            .course-categoryName {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            span {
              font-size: 14px;
              font-weight: 600;
              color: #4a4a4a;
            }
          }
          .course-status {
            font-size: 12px;
            color: #929292;
            .icon-clock {
              font-size: 12px;
              margin-right: 3px;
            }
          }
        }
        .right {
          text-align: right;
          padding-left: 0;
          i {
            font-size: 12px;
            color: #394a54;
            float: right;
          }
        }
      }
    }
  }
</style>